import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,1242.34165 C1022.23059,1242.34165 1072.94118,1293.05224 1072.94118,1355.28282 C1072.94118,1417.51341 1022.23059,1468.224 960,1468.224 C897.769412,1468.224 847.058824,1417.51341 847.058824,1355.28282 C847.058824,1293.05224 897.769412,1242.34165 960,1242.34165 Z M1049.33647,350.332235 C1164.19765,380.035765 1257.6,473.438118 1287.30353,588.299294 C1310.68235,678.765176 1298.03294,771.602824 1251.84,849.758118 C1206.32471,926.896941 1130.65412,983.706353 1044.25412,1005.84282 C1030.47529,1009.45694 1016.47059,1020.63812 1016.47059,1037.80518 L1016.47059,1129.40047 L903.529412,1129.40047 L903.529412,1037.80518 C903.529412,971.621647 949.835294,913.569882 1016.24471,896.515765 C1073.84471,881.720471 1124.21647,843.772235 1154.59765,792.384 C1185.43059,740.092235 1193.78824,677.748706 1177.97647,616.534588 C1158.32471,540.864 1096.77176,479.311059 1021.10118,459.659294 C950.174118,441.475765 877.665882,455.706353 821.76,498.962824 C766.08,542.106353 734.117647,607.273412 734.117647,677.635765 L621.176471,677.635765 C621.176471,572.035765 669.063529,474.341647 752.64,409.626353 C836.329412,344.798118 944.414118,323.339294 1049.33647,350.332235 Z M960,-0.0112941176 C430.644706,-0.0112941176 0,430.633412 0,959.988706 C0,1489.344 430.644706,1919.98871 960,1919.98871 C1489.46824,1919.98871 1920,1489.344 1920,959.988706 C1920,430.633412 1489.46824,-0.0112941176 960,-0.0112941176",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconQuestionSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconQuestionSolid, _Component);

  var _super = _createSuper(IconQuestionSolid);

  function IconQuestionSolid() {
    _classCallCheck(this, IconQuestionSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconQuestionSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconQuestion",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconQuestionSolid.displayName = "IconQuestionSolid";
  return IconQuestionSolid;
}(Component);

IconQuestionSolid.glyphName = 'question';
IconQuestionSolid.variant = 'Solid';
IconQuestionSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconQuestionSolid;
export { IconQuestionSolid };